module.exports = __webpack_public_path__ + "img/S_9576_microbiome_hannah_rose_wardill.655155ff.jpg";